import guid from '@/shared/utils/guid';

export const datasetColors = [
  'rgba(0, 178, 149, 1)', // Done
  'rgba(240, 168, 0, 1)', // In progress
  'rgba(214, 214, 214, 1)', // Todo
  'rgba(184, 0, 22, 1)', // Blocked
];

const statusCodes = [2, 1, 0, 3]; // Todo: Fix blocked status code
const fiscalTypes = [2, 3, 4, 5];
export const getDatasetStatus = index => {
  if (index < 0 || index >= statusCodes.length) return null;
  return statusCodes[index];
};

export const getStateParamsFromTask = task => {
  if (!task) return {};

  const result = {
    taskId: task.templateId,
    periodicityId: task.periodicityId ?? guid.empty,
    periodicityLineId: task.periodicityLineId ?? guid.empty,
    deadlineFrom: task.minDeadline,
    deadlineUntil: task.maxDeadline,
  };
  if (task.year && task.lineType > 1) {
    if (fiscalTypes.indexOf(task.lineType) >= 0) {
      result.fiscalEndYear = task.year;
    } else {
      result.year = task.year;
    }
  }
  return result;
};

export const getStateParamsFromEvent = (data, event) => {
  if (!event) return null;
  const task = data[event.index];
  const statusCode = getDatasetStatus(event.datasetIndex);
  return { ...getStateParamsFromTask(task), mainStatus: [statusCode] };
};
